import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../layouts/user';
import WhitelistForm from '../../components/wallet/whitelistForm';
import NeedVerification from '../../components/common/needVerification';
import { post, upload } from '../../libs/api';
import { getUser } from '../../libs/user';
import { Errors, Successes } from '../../components/common/msg';

function Page() {
  const [loading, setLoading] = useState(false);
  const [verified, setVerified] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState([]);
  const [successes, setSuccesses] = useState([]);

  const navigate = useNavigate();

  const resetError = () => {
    setErrors([]);
    if (document.getElementById('address'))
      document.getElementById('address').classList.remove('error');

    return;
  };

  const handleFormSubmitted = async (
    purpose,
    coin,
    network,
    address,
    isHardware,
    vasp,
    vaspDetail,
    beneficiaryName,
    files,
    notes,
    needsSatoshiTest
  ) => {
    resetError();

    const data = await post('/wallet/whitelist/validate', {
      purpose,
      currency: coin,
      network,
      address,
      note: notes,
      is_hardware: isHardware,
      vasp,
      beneficiary_name: beneficiaryName,
    });

    if (data?.status != 200) {
      setSubmitting(false);
      setErrors([data.error]);

      if (
        data.error.startsWith('Address is not a valid blockchain wallet.') ||
        data.error.startsWith('There are already 2 whitelist added for') ||
        data.error.startsWith('Client Whitelist is existing')
      ) {
        if (document.getElementById('address'))
          document.getElementById('address').classList.add('error');
      }
      document.documentElement.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest',
      });

      return;
    }

    let fileIds = [];
    // Handle multiple file uploads (up to 3)
    if (files?.length > 0) {
      setSubmitting(true);
      try {
        // Upload all files in parallel
        const uploadPromises = files.map((file) =>
          upload('/wallet/file/upload', file)
        );

        const results = await Promise.all(uploadPromises);

        // Check for any failed uploads
        const failedUpload = results.find((result) => result?.status !== 200);
        if (failedUpload) {
          setSubmitting(false);
          setErrors([
            'Error uploading one or more proof of ownership documents',
          ]);
          return;
        }

        // Collect all successful file IDs
        fileIds = results.map((result) => result.data.file_id);
      } catch (error) {
        setSubmitting(false);
        setErrors(['Error uploading documents']);
        return;
      }
    } else {
      console.log(
        'proof of ownership is optional for isHardware ' + isHardware
      );
    }

    const params = {
      purpose,
      currency: coin,
      network,
      address,
      is_hardware: isHardware,
      vasp: isHardware ? '' : vasp,
      vasp_detail: isHardware ? '' : vaspDetail,
      beneficiary_name: beneficiaryName,
      file_ids: fileIds,
      note: notes,
      needs_satoshi_test: needsSatoshiTest ? true : false,
    };

    await handleVerifySubmit(params);
  };

  const handleVerifySubmit = async (params) => {
    setSubmitting(true);
    resetError();
    setSuccesses([]);

    const data = await post('/wallet/whitelist/add', params);
    if (data?.status != 200) {
      setSubmitting(false);
      setErrors([data.error]);

      if (data.error == 'Address is not a valid blockchain wallet.') {
        if (document.getElementById('address'))
          document.getElementById('address').classList.add('error');
      }
      document.documentElement.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest',
      });
      return;
    }
    setSuccesses(['The whitelist address has been submitted.']);
    navigate('/portal/wallet/whitelist');
  };

  const initLoad = async () => {
    setLoading(true);
    const user = await getUser();
    if (user) {
      setVerified(user.profileVerified);
    }
    setLoading(false);
  };

  useEffect(() => {
    // initLoad();
  }, []);

  return (
    <Layout>
      {!loading && !verified && <NeedVerification />}

      <div className="page-invest wide-xs m-auto" id="iv-step-container">
        <div className="nk-pps-apps">
          {/* <div className="nk-pps-steps">
            <span className={step == 1 ? "step active" : "step"}></span>
            <span className={step == 2 ? "step active" : "step"}></span>
          </div> */}

          {errors.length > 0 && <Errors errors={errors} />}
          {successes.length > 0 && <Successes msgs={successes} />}

          {!loading && verified && (
            <>
              <div className="nk-pps-title text-center">
                <h3 className="title">Add New WhiteList Address</h3>
                <p className="caption-text"></p>
              </div>
              <WhitelistForm
                onSubmit={handleFormSubmitted}
                submitting={submitting}
              />
            </>
          )}
        </div>
      </div>
    </Layout>
  );
}

export default Page;
